import { useEffect, useRef, useState } from "react";

/* The partner's opening message as a floating note: slides in at the bottom
   shortly after landing and stays until the visitor dismisses it with the
   close button. Bottom-right on desktop, full-width above the bottom edge
   on small screens. */
const APPEAR_AFTER_MS = 600;

export default function PartnerNote({ partnerName, message }) {
  const [visible, setVisible] = useState(false);
  const dismissed = useRef(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (!dismissed.current) setVisible(true);
    }, APPEAR_AFTER_MS);
    return () => clearTimeout(timer);
  }, []);

  const dismiss = () => {
    dismissed.current = true;
    setVisible(false);
  };

  return (
    <div
      role="status"
      aria-live="polite"
      className={`fixed inset-x-4 bottom-4 z-50 transition-all duration-500 sm:inset-x-auto sm:bottom-6 sm:right-6 sm:max-w-sm ${
        visible ? "translate-y-0 opacity-100" : "pointer-events-none translate-y-6 opacity-0"
      }`}
    >
      <div className="card relative flex items-start gap-3.5 p-5 !shadow-float">
        <span className="text-xl" aria-hidden="true">💬</span>
        <div className="min-w-0 pr-5">
          <p className="text-sm font-semibold">A note from {partnerName}</p>
          <p className="mt-1 whitespace-pre-line text-sm leading-relaxed text-ink-soft">{message}</p>
        </div>
        <button
          type="button"
          onClick={dismiss}
          aria-label="Dismiss note"
          className="absolute right-2.5 top-2.5 flex h-6 w-6 items-center justify-center rounded-full text-ink-soft transition hover:bg-ink/5 hover:text-ink"
        >
          <svg className="h-3.5 w-3.5" viewBox="0 0 16 16" fill="none" aria-hidden="true">
            <path d="M4 4l8 8M12 4l-8 8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
          </svg>
        </button>
      </div>
    </div>
  );
}
